import { AdobeMethods } from '../../../../services/adobe-launch/adobe-launch.methods';
import { AdobePageName } from '../../../../services/adobe-launch/adobe-launch.pages';
import { AnalyticsCtaType, CtaCallUsLinkLocations, CtaNames } from '../../../../services/adobe-launch/adobe-launch.cta';

export const adobeConfigData = {
    limitedAccessPageName: [
        {
            method: AdobeMethods.PAGE_LOAD,
            data: [AdobePageName.GAF_SELECT_ACCOUNTS_LIMITED],
        },
    ],
    infoOnlyAccessPageName: [
        {
            method: AdobeMethods.PAGE_LOAD,
            data: [AdobePageName.GAF_SELECT_ACCOUNTS_INFO_ONLY],
        },
    ],
    onNextStepLoadLimited: [
        {
            method: AdobeMethods.TRACK_ACTION,
            data: [
                {
                    ctaName: CtaNames.CONTINUE,
                    ctaType: AnalyticsCtaType.BUTTON,
                    location: CtaCallUsLinkLocations.ZCI_SELECT_ACCOUNTS_STEP_LIMITED,
                },
            ],
        },
    ],
    onNextStepLoadInfoOnly: [
        {
            method: AdobeMethods.TRACK_ACTION,
            data: [
                {
                    ctaName: CtaNames.CONTINUE,
                    ctaType: AnalyticsCtaType.BUTTON,
                    location: CtaCallUsLinkLocations.ZCI_SELECT_ACCOUNTS_STEP_INFO_ONLY,
                },
            ],
        },
    ],
};
